enum CustodianName {
  NEOKRED = 'neokred',
  INDIAN_BANK = 'indian_bank',
}

type MaintenanceConfig = {
  start_time: string | null;
  end_time: string | null;
};

interface BaseCustodian {
  asset_symbol: 'INR';
  base_deposit_fee: number;
  custodian_network: string;
  delta_wallet_address: null | string;
  is_subaccount_allowed: boolean;
  max_deposit_amount: number;
  min_deposit_amount: number;
  network: string;
  payment_tag: null | string;
  sort_priority: null | number;
  variable_deposit_fee: number;
}

interface NeokredCustodian extends BaseCustodian {
  fiat_deposit_custodian: CustodianName.NEOKRED;
  maintenance_config: {
    UPI: MaintenanceConfig;
    IMPS: MaintenanceConfig;
  };
}

interface IndianBankCustodian extends BaseCustodian {
  fiat_deposit_custodian: CustodianName.INDIAN_BANK;
  maintenance_config: {
    NEFT: MaintenanceConfig;
  };
}

type Custodian = NeokredCustodian | IndianBankCustodian;

interface MaintenanceState {
  neokredUpi: MaintenanceConfig | null;
  neokredImps: MaintenanceConfig | null;
  indianBankNeft: MaintenanceConfig | null;
}

export type { Custodian, MaintenanceState, MaintenanceConfig };
export { CustodianName };
